// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"03766df0","239":"7172428c","455":"5da4dd71"}[chunkId] + ".chunk.js";
};